<div class="tw:text-end tw:mb-4">
	<button (click)="close()" class="tw:bg-transparent tw:text-secondary tw:border-none tw:text-base tw:font-medium">
		Close
	</button>
</div>

<div class="tw:flex tw:flex-col tw:gap-4 tw:pb-4">
	@if (userRole.isStoresManager()) {
		@if (userPermissions.canAccessExpenses()) {
		<app-bottom-menu-sheet-item icon="local_shipping" routerLink="/expense/suppliers" routerLinkActive="active">
			{{ "expenses.suppliers.title" | translate }}
		</app-bottom-menu-sheet-item>
		}
		@if (userPermissions.canAccessPayroll() && userPermissions.canAccessExpenses() && (school.isKenyanSchool || school.isUgandanSchool)) {
		<app-bottom-menu-sheet-item icon="groups" [routerLink]="school.isPrivateSchool ? '/staff' : '/payroll/staff-management'" routerLinkActive="active">
			{{ "sideMenu.staffManagement" | translate }}
		</app-bottom-menu-sheet-item>
		}
	} @else {

	<app-bottom-menu-sheet-item icon="space_dashboard" routerLink="/dashboard" routerLinkActive="active">
		{{ "sideMenu.dashboard" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="groups" routerLink="/students" routerLinkActive="active">
		{{ "sideMenu.students" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="checkbook" routerLink="/invoicing" routerLinkActive="active">
		{{ "sideMenu.invoicing" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="money_bag" routerLink="/collections" routerLinkActive="active">
		{{ "sideMenu.collections" | translate }}
	</app-bottom-menu-sheet-item>

	@if (userPermissions.canAccessExpenses()) {
		<app-bottom-menu-sheet-item icon="payment_arrow_down" routerLink="/expense" routerLinkActive="active">
			{{ "sideMenu.expenses" | translate }}
		</app-bottom-menu-sheet-item>
	}

	<app-bottom-menu-sheet-item icon="home_repair_service" routerLink="/other-income" routerLinkActive="active">
		{{ "sideMenu.otherIncome" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="rule_settings" routerLink="/integrations" routerLinkActive="active">
		{{ "setting.intergrations.intergrations" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="account_balance" routerLink="/accounting" routerLinkActive="active">
		{{ "sideMenu.accounting" | translate }}
	</app-bottom-menu-sheet-item>

	@if (userPermissions.canAccessPayroll() && userPermissions.canAccessExpenses() && school.isKenyanSchool) {
		<app-bottom-menu-sheet-item icon="folder_shared" [hasSubMenu]="true">
			{{ "sideMenu.staffAndPayroll" | translate }}
			<z-sub-menu>
				<z-sub-menu-item route="/payroll/general-setup">{{ "sideMenu.payrollSetup" | translate }}</z-sub-menu-item>
				@if (school.isPrivateSchool) {
					<z-sub-menu-item route="/staff">{{ "sideMenu.staffManagement" | translate }}</z-sub-menu-item>
				} @else {
					<z-sub-menu-item route="/payroll/staff-management">
						{{ "sideMenu.staffManagement" | translate }}
					</z-sub-menu-item>
				}
				<z-sub-menu-item route="/payroll/payroll-management">
					{{ "sideMenu.payrollManagement" | translate }}
				</z-sub-menu-item>
			</z-sub-menu>
		</app-bottom-menu-sheet-item>
	}

	<app-bottom-menu-sheet-item icon="lab_profile" [hasSubMenu]="true">
		{{ "sideMenu.reports" | translate }}
		<z-sub-menu>
			<z-sub-menu-item route="/student-reports">{{ "sideMenu.studentReports" | translate }}</z-sub-menu-item>
			<z-sub-menu-item route="/summary-reports">{{ "sideMenu.summaryReports" | translate }}</z-sub-menu-item>
			@if (school.isPrivateSchool) {
				<z-sub-menu-item route="/private-financial-reports">
					{{ "sideMenu.financialReports" | translate }}
				</z-sub-menu-item>
			} @else if (userPermissions.canAccessFinancialReports() && userPermissions.canAccessExpenses()) {
				<z-sub-menu-item route="/financial-reports">{{ "sideMenu.financialReports" | translate }}</z-sub-menu-item>
				<z-sub-menu-item route="/ipsas-reports">{{ "sideMenu.ipsasReports" | translate }}</z-sub-menu-item>
			}
			<z-sub-menu-item route="/aging-reports">{{ "sideMenu.agingReports" | translate }}</z-sub-menu-item>
		</z-sub-menu>
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="store" [hasSubMenu]="true">
		{{ "sideMenu.storesAndInventory" | translate }}
		<z-sub-menu>
			<z-sub-menu-item route="/stores-inventory/setup">{{ "sideMenu.setup" | translate }}</z-sub-menu-item>
			<z-sub-menu-item route="/stores-inventory/inventory-register">
				{{ "sideMenu.inventoryRegister" | translate }}
			</z-sub-menu-item>
			<z-sub-menu-item route="/stores-inventory/internal-use-items">
				{{ "sideMenu.itemIssuance" | translate }}
			</z-sub-menu-item>
			<z-sub-menu-item route="/stores-inventory/inventory-reports">
				{{ "sideMenu.inventoryReports" | translate }}
			</z-sub-menu-item>
		</z-sub-menu>
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="directions_bus" routerLink="/transport">Transport</app-bottom-menu-sheet-item>

	@if (userPermissions.canAccessPocketMoney()) {
		<app-bottom-menu-sheet-item icon="payments" routerLink="/pocket-money">
			{{ "sideMenu.pocketMoney" | translate }}
		</app-bottom-menu-sheet-item>
	}

	<app-bottom-menu-sheet-item icon="forum" routerLink="/messaging">
		{{ "sideMenu.messaging" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="assignment" routerLink="/asset-management">
		{{ "sideMenu.assetManagement" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="build" routerLink="/configurations">
		{{ "sideMenu.configurations" | translate }}
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item icon="delete" routerLink="/deletion-logs">
		{{ "deletionLogs.deletionLogs" | translate }}
	</app-bottom-menu-sheet-item>
	}
</div>
